import { Avatar, Box, Icon } from '@zillow/constellation-10';
import { IconSparkleFilled, IconZillowMark } from '@zillow/constellation-icons';
import GradientCircle from '../icons/GradientCircle';
import { avatarContainerStyles } from './styles';

type ChatAvatarProps = {
  hasTimestampInMessage?: boolean;
  senderFullName?: string | null;
  type: 'bot' | 'user' | 'zillow';
};

export default function ChatAvatar({ senderFullName, hasTimestampInMessage = true, type }: ChatAvatarProps) {
  if (type === 'bot') {
    return (
      <Box
        css={{
          ...avatarContainerStyles,
          marginBottom: hasTimestampInMessage ? 'loose' : 'tighter',
        }}
      >
        <GradientCircle />
        <Icon
          data-testid="sparkles-icon"
          css={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <IconSparkleFilled />
        </Icon>
      </Box>
    );
  }

  if (type === 'zillow') {
    return (
      <Box
        css={{
          ...avatarContainerStyles,
          marginBottom: hasTimestampInMessage ? 'loose' : 'tighter',
        }}
      >
        <Avatar
          aria-label="Zillow"
          size="sm"
          tone="accent-1"
          icon={<IconZillowMark />}
          css={{ backgroundColor: 'bg.accent.brand.hero-fixed' }}
        />
      </Box>
    );
  }

  return (
    <Box
      css={{
        ...avatarContainerStyles,
        marginBottom: hasTimestampInMessage ? 'loose' : 'tighter',
      }}
    >
      <Avatar
        aria-label={senderFullName || 'User'}
        fullName={senderFullName || ''}
        size="sm"
        tone="default"
        css={{ textTransform: 'capitalize' }}
      />
    </Box>
  );
}
